import { Localization, enUS, nlNL } from '@mui/material/locale';
import { Locale } from '@kamernet/core/Intl/types';

export const MuiLocalesMap: Record<Locale, Localization> = {
  [Locale.en]: enUS,
  [Locale.nl]: nlNL,
};
